import React from 'react'
import { connect } from 'react-redux'
import { F7App, View } from 'framework7-react'
import { hotjar } from 'react-hotjar'

import routes from './routes'

import { watchKeyboardVisibility } from './store/actions/virtualKeyboard'
import { loadFeatureFlags } from './store/actions/featureFlags'
import { checkAppVersion } from './store/actions/appVersion'
import VersionWarningModal from './components/VersionWarningModal/VersionWarningModal'
import { APP_NAME } from './utils/createPageTitle'

const f7params = {
  name: APP_NAME,
  id: 'com.corteva.workflow',
  touch: { fastClicks: true },
  routes,
}

if (process.env.REACT_APP_HOTJAR_ID) {
  hotjar.initialize(process.env.REACT_APP_HOTJAR_ID, 6)
}

class MobileMain extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    this.$f7ready(() => {
      if (window.location.pathname === '/') window.location.pathname = '/home'
    })
    this.props.watchVirtualKeyboard()
    if (this.props.token) {
      this.props.loadFeatureFlags()
      this.props.checkAppVersion()
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.token && this.props.token) {
      this.props.loadFeatureFlags()
      this.props.checkAppVersion()
    }
  }

  render() {
    const { isKeyboardUp } = this.props

    return (
      <F7App
        params={f7params}
        colorTheme="#04223B"
        className={`${isKeyboardUp ? 'device-keyboard-visible' : ''}`}
      >
        <VersionWarningModal />
        <View
          main
          iosSwipeBack={false}
          auroraSwipeBack={false}
          mdSwipeBack={false}
          url="/"
          pushState
          pushStateRoot={window.location.origin}
          pushStateSeparator=""
        />
      </F7App>
    )
  }
}

const mapStateToProps = state => ({
  isKeyboardUp: state.keyboard.isVisible,
  token: state.auth?.token,
})

const mapDispatchToProps = dispatch => ({
  watchVirtualKeyboard: () => dispatch(watchKeyboardVisibility()),
  loadFeatureFlags: () => dispatch(loadFeatureFlags()),
  checkAppVersion: () => dispatch(checkAppVersion()),
})

export default connect(mapStateToProps, mapDispatchToProps)(MobileMain)
